import { Component, OnInit } from '@angular/core';
import { ReportsService } from 'src/app/_services/reports/reports.service';
import Chart from 'chart.js';
import {
  chartOptions,
  parseOptions,
  randomColor,
  chartBarStackedData,
  chartDoughnutData,
  chartPolarData,
  chartPieData,
  chartPointsData,
  chartSalesData,
  chartBarsData,
  chartHorizontalBarsData,
} from './variables/charts-variables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  title: string = 'Top Labs Report';
  data = {
    labels: [],
    datasets: [],
  };
  isData: boolean = false;
  type: string = 'bar';
  dataType: string = 'chartBarStackedData';
  params = {
    returnRowsNumber: '5',
    startDate: '2021-07-27',
    endDate: '2021-08-2',
    testTypesIds: '2',
    reservationStatusIds: '3',
  };

  constructor(private reportsService: ReportsService) {}

  ngOnInit(): void {
    parseOptions(Chart, chartOptions());

    this.getTopLabsStats();

    // Start line chart
    chartSalesData.data = {
      labels: [
        '02-Jan',
        '03-Jan',
        '04-Jan',
        '05-Jan',
        '06-Jan',
        '07-Jan',
        '08-Jan',
      ],
      datasets: [
        {
          borderColor: '#ff0000',
          data: [0, 1, 3, 0, 0, 0, 0],
          label: 'Total Approvals',
          lineTension: 0,
          fill: false,
        },
        {
          borderColor: '#00ff00',
          data: [0, 1, 5, 0, 0, 0, 0],
          label: 'Total Reimbursements',
          lineTension: 0,
          fill: false,
        },
        {
          borderColor: '#0000ff',
          data: [0, 2, 8, 0, 0, 0, 0],
          label: 'All TPA Requests',
          lineTension: 0,
          fill: false,
        },
      ],
    };
    var chartSales = document.getElementById('chart-sales');
    var salesChart = new Chart(chartSales, {
      type: 'line',
      data: chartSalesData.data,
      options: chartSalesData.options,
    });
    // End line chart

    // Start pie chart
    chartPieData.data = {
      labels: ['Total Calls', 'Total No Shows'],
      datasets: [
        {
          data: [110, 32],
          backgroundColor: ['#ff0000', '#0000ff'],
          label: 'Dataset 1',
        },
      ],
    };
    var chartPie = document.getElementById('chart-pie');
    var pieChart = new Chart(chartPie, {
      type: 'pie',
      data: chartPieData.data,
      options: chartPieData.options,
    });
    // End pie chart

    // Start bars chart
    chartBarsData.data = {
      labels: ['Pediatrics', 'Nutrition', 'General', 'Total Consultations'],
      datasets: [
        {
          label: 'Speciality',
          data: [45, 48, 20, 93],
        },
      ],
    };
    var chartBars = document.getElementById('chart-bars');
    var barsChart = new Chart(chartBars, {
      type: 'bar',
      data: chartBarsData.data,
    });
    // End bars chart

    // Start points chart
    chartPointsData.data = {
      labels: [
        '01-Jan',
        '02-Jan',
        '03-Jan',
        '04-Jan',
        '05-Jan',
        '06-Jan',
        '07-Jan',
        '08-Jan',
        '09-Jan',
        '10-Jan',
        'Total Emergency Calls',
      ],
      datasets: [
        {
          label: 'Emergency Calls',
          data: [190, 398, 295, 307, 333, 219, 196, 192, 204, 212, 2546],
          pointRadius: 5,
          pointHoverRadius: 7,
          showLine: false,
        },
      ],
    };
    var chartPoints = document.getElementById('chart-points');
    var pointsChart = new Chart(chartPoints, {
      type: 'line',
      data: chartPointsData.data,
      options: chartPointsData.options,
    });
    // End points chart

    // Start doughnut chart
    chartDoughnutData.data = {
      labels: ['Cataflam', 'AAA', 'BBB'],
      datasets: [
        {
          data: [72, 49, 29],
          backgroundColor: ['#ff0000', '#00ff00', '#0000ff'],
          label: 'Top Product',
        },
      ],
    };
    var chartDoughnut = document.getElementById('chart-doughnut');
    var doughnutChart = new Chart(chartDoughnut, {
      type: 'doughnut',
      data: chartDoughnutData.data,
      options: chartDoughnutData.options,
    });
    // End doughnut chart

    // Start polar chart
    chartPolarData.data = {
      labels: ['Cataflam', 'AAA', 'BBB'],
      datasets: [
        {
          data: [72, 49, 29],
          backgroundColor: ['#ff0000', '#00ff00', '#0000ff'],
          label: 'Top Product',
        },
      ],
    };
    var chartPolar = document.getElementById('chart-polar');
    var doughnutChart = new Chart(chartPolar, {
      type: 'polarArea',
      data: chartDoughnutData.data,
      options: chartDoughnutData.options,
    });
    // End polar chart

    // Start horizontal bars chart
    chartHorizontalBarsData.data = {
      labels: ['Total Consultations', 'Pediatrics', 'Nutrition', 'General'],
      datasets: [
        {
          label: 'Speciality',
          data: [93, 45, 48, 20],
        },
      ],
    };
    var chartBars = document.getElementById('chart-horizontalbars');
    var barsChart = new Chart(chartBars, {
      type: 'horizontalBar',
      data: chartHorizontalBarsData.data,
      options: chartHorizontalBarsData.options,
    });
    // End horizontal bars chart
  }

  getTopLabsStats() {
    this.reportsService.getTopLabsStats(this.params).subscribe((response) => {
      let labsTopItems = response['data'].topItems;

      let chartConfig = {
        labsTotalItems: 0,
        labNameArray: [],
        labTotalItemsArray: [],
        labItemsPerDayKeysArray: [],
        labItemsPerDayValuesArray: [],
      };

      chartConfig.labsTotalItems = response['data'].totalItems;

      labsTopItems.forEach((lab) => {
        chartConfig.labNameArray.push(lab.columns.Name);
        chartConfig.labTotalItemsArray.push(lab.totalItems);
        chartConfig.labItemsPerDayKeysArray.push(Object.keys(lab.itemsPerDay));
        chartConfig.labItemsPerDayValuesArray.push(
          Object.values(lab.itemsPerDay)
        );
      });

      this.data.labels = chartConfig.labNameArray;

      let datasetLengthArray = chartConfig.labItemsPerDayValuesArray.map(
        (a) => a.length
      );

      let datasetMaxLength = Math.max(...datasetLengthArray);

      for (let i = 0; i < datasetMaxLength; i++) {
        let dataset = {
          backgroundColor: randomColor(),
          label: '',
          data: [],
        };

        for (let j = 0; j < chartConfig.labNameArray.length; j++) {
          dataset.data.push(chartConfig.labItemsPerDayValuesArray[j][i] || 0);
        }

        this.data.datasets.push(dataset);
      }

      this.isData = true;
    });
  }
}
